
import { schemaAvailability } from '@/utils/schemaAvailability'
import {
  schemaBrand,
  schemaIdentifiers,
} from '@/utils/productSchemaIdentifiers'
export default {
  name: 'H7ComparisonStructuredData',
  props: {
    name: {
      type: String,
      default: 'Comparatif des meilleures ampoules LED H7',
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  head() {
    if (!this.products.length) return {}
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          hid: 'h7-comparison-structured-data',
          innerHTML: JSON.stringify(this.structuredData),
          type: 'application/ld+json',
        },
      ],
    }
  },
  computed: {
    structuredData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: this.name,
        url: this.$config.url + this.$route.path,
        numberOfItems: this.productNodes.length,
        itemListElement: this.productNodes.map((node, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: node,
        })),
      }
    },
    productNodes() {
      return this.products
        .filter(product => product?.variant)
        .map(product => {
          const variant = product.variant
          const url = `${this.$config.url}${this.localePath({
            name: 'produit-slug',
            params: { slug: product.slug },
          })}`
          const node = {
            '@type': 'Product',
            name: product.name,
            url,
            brand: schemaBrand(product),
            ...schemaIdentifiers(product, variant),
          }
          const image = this.absoluteImage(variant.images?.[0]?.url)
          if (image) node.image = image
          if (variant.price_ttc_base) {
            node.offers = {
              '@type': 'Offer',
              url,
              price: this.$options.filters.number(
                variant.price_ttc_base,
                '0.00'
              ),
              priceCurrency: 'EUR',
              availability: this.getAvailability(variant),
              itemCondition: 'https://schema.org/NewCondition',
            }
          }
          return node
        })
    },
  },
  methods: {
    getAvailability(variant) {
      return schemaAvailability(variant)
    },
    absoluteImage(url) {
      if (!url) return null
      return url.startsWith('http') ? url : `${this.$config.url}${url}`
    },
  },
}
